@if (showErrors && error) {
  <div class="mb-5 mt-3">
    <p-message [severity]="error.severity" [text]="error.text" />
  </div>
}
<div class="grid mb-3">
  <div class="col-12 grid">
    @if (!hideSearch) {
      <div class="col-6">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-search" />
          <input
            type="text"
            pInputText
            (keydown.enter)="filterGlobal($event)"
            placeholder="{{ 'importHistory.serachImport' | translate }}"
          />
        </p-iconField>
      </div>
    }
    @if (!hideFilters) {
      <div class="col-6 text-right">
        <p-button [outlined]="true" (click)="openFilterModal()">
          <i class="pi pi-filter"></i>
          @if (tags.length > 0) {
            <p-badge
              [value]="tags.length"
              severity="info"
              class="flex align-content-center filter-badge"
            />
          }
          <span class="pl-2 font-semibold">{{'global.filter' | translate}}</span>
        </p-button>
      </div>
    }

    @if (tags.length > 0) {
      @for (tag of tags; track $index) {
        <p-tag class="ml-3 mb-1">
          <span>{{tag.header | translate}}{{ ": " }} 
            @if (!tag.isMultiple) {
              {{ tag.valueString | translate}}
            } @else {
              @for (item of tag.valueString; track $index) {
                {{ item | translate }}{{ $index < tag.valueString.length - 1 ? ', ' : '' }}
              }
            }
          </span>
          <i class="pi pi-times-circle ml-1 cursor-pointer" (click)="removeFilter(tag.name, tag.parent)"></i>
        </p-tag>
      }
      <span
        style="color: #aaa"
        class="pl-3 flex align-items-center cursor-pointer underline"
        (click)="resetFilters()"
      >
      {{'global.removeFilter' | translate}}
      </span>
    }
  </div>
</div>
<p-table
  #dt2
  class="table-shadow"
  [value]="importHistory"
  [scrollable]="true"
  selectionMode="single"
  [rowHover]="true"
  [loading]="isLoading"
  scrollHeight="400px"
  [paginator]="true"
  [rows]="rows"
  [totalRecords]="totalRecords"
  [lazy]="true"
  [sortOrder]="-1"
  [style]="{'min-width': '800px'}"
  (onLazyLoad)="onLazyLoad($event)"
>
  <ng-template pTemplate="header">
    <tr>
      @for (header of headers; track $index) {
        @if (header.id == "download") {
          <th
            style="font-size: 0.9rem; font-weight: 700"
            [id]="header.id"
            pFrozenColumn
            [frozen]="true"
            alignFrozen="right"
            [style.width]="'100px'"
          >
            <span>{{ header.value | translate}}</span>
          </th>
        } @else if(header.id == "fileName") {
          <th
            [pSortableColumn]="header.sortField || header.field"
            style="font-size: 0.9rem; font-weight: 700"
            [id]="header.id"
            pFrozenColumn
            [frozen]="true"
            [style.width]="'200px'"
          >
            <span>{{ header.value  | translate}}</span>
            <p-sortIcon [field]="header.id" class="ml-1"/>
          </th>
        } @else {
          <th
            [pSortableColumn]="header.sortField || header.field"
            style="font-size: 0.9rem; font-weight: 700"
            [id]="header.id"
          >
            <span>{{ header.value  | translate}}</span>
            @if(header.tooltip) {
              <i class="pi pi-question-circle pl-2 pt-1 color-link-primary vertical-align-top" 
              tooltipPosition="bottom"
              [pTooltip]="header.tooltipValue | translate"></i>
            }
            <p-sortIcon [field]="header.id" class="ml-1" />            
          </th>
        }
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-importHistory>
    <tr style="cursor: pointer" (click)="rowClick($event, importHistory)">
      @for (header of headers; track $index) {
        @if (header.id == "status") {
          <td>
            <p-tag [severity]="getSeverity(importHistory[header.id])">
              {{ importHistory[header.id] | translate }}
            </p-tag>
          </td>
        } @else if (header.id == "download") {
          <td pFrozenColumn [frozen]="true" alignFrozen="right">
            <div
              style="display: flex; gap: 7px"
              (click)="$event.stopPropagation()"
            >
              <p-splitButton
                [buttonDisabled]="true"
                icon="pi pi-download"
                (onDropdownClick)="onDropdownClick($event)"
                [model]="importHistory.actions"
                appendTo="body"
                (click)="$event.stopPropagation()"
                (onShow)="$event.stopPropagation()"
                [ngClass]="{
                  'warning-split-button':
                    getImportReportButtonSeverity(importHistory) ===
                    'warning-split-button',
                }"
              >
              </p-splitButton>
            </div>
          </td>
        } @else if (header.id === "fileName") {
          <td pFrozenColumn [frozen]="true">
            {{ importHistory[header.id] }}
          </td>
        } @else if (header.id === "importDate") {
          <td>
            {{ importHistory[header.id] | date: "dd-MM-yyyy HH:mm:ss" }}
          </td>
        } @else if (header.id === "linesImportSuccess") {
          <td>
            <span
              [ngClass]="{
                'text-red':
                  importHistory[header.id] != importHistory['totalLines'],
              }"
              >{{ importHistory[header.id] }} /
              {{ importHistory["totalLines"] }}</span
            >
          </td>
        } @else if(header.id === "linesWithErrors" || header.id === "linesRejected"){
          <td>
            <span
              [ngClass]="{
                'text-red':
                  importHistory[header.id] != 0,
              }"
              >{{ importHistory[header.id] }}</span
            >
          </td>
        } @else if(header.id === "mappingNeeded"){
          <td>
            @if(importHistory[header.id] == true) {
              <span>{{'importHistory.yes' | translate}}</span>
            }@else {
              <span>{{ 'importHistory.no' | translate  }}</span>
            }
        
          </td>
        } @else {
          <td>
            {{ importHistory[header.id] }}
          </td>
        }
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="paginatorleft">
    <span class="current-page-report">
      {{ (searchData.page - 1) * rows + 1 }} -
      {{
        (searchData.page - 1) * rows + rows > totalRecords
          ? totalRecords
          : (searchData.page - 1) * rows + rows
      }}
     {{ 'table.of' | translate}} {{ totalRecords }} {{'table.results' | translate}}
    </span>
    <p-select
      [options]="rowsPerPageOptions"
      [(ngModel)]="rows"
      (onChange)="onRowsPerPageChange($event)"
      optionLabel="label"
      optionValue="value"
    >
    </p-select>
  </ng-template>
</p-table>
<p-toast />